/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-button': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M29 8H18C10.82 8 5 13.82 5 21v6c0 7.18 5.82 13 13 13h11c7.18 0 13-5.82 13-13v-6c0-7.18-5.82-13-13-13zM18 5C9.163 5 2 12.163 2 21v6c0 8.837 7.163 16 16 16h11c8.837 0 16-7.163 16-16v-6c0-8.837-7.163-16-16-16H18z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M23.01 16.01a1.4 1.4 0 0 1 1.98 0l7 7a1.4 1.4 0 0 1 0 1.98l-7 7a1.4 1.4 0 0 1-1.98-1.98l4.61-4.61H17a1.4 1.4 0 1 1 0-2.8h10.62l-4.61-4.61a1.4 1.4 0 0 1 0-1.98z"/>'
  }
})
